export default "__VITE_ASSET__CDIXB2pV__"